module.exports = {
    ASYNC_REQUEST_ERROR: 'ASYNC_REQUEST_ERROR',
};
